import { useState } from 'react';
import { SMSPassword, UpdateHistory } from './components';
import { Box, Tab, Tooltip, Tabs, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIContent } from '@/atomic/organisms';
import { SCUIBreadCrumb } from '@/atomic/molecules';
import { SCUIButton, SCUINoRecordComponent } from '@/atomic/atoms';
import { OTPP } from './otpPassword.classes';

export const OTPPassword = () => {
    const countries = JSON.parse(localStorage.getItem('countryData') || '{}')?.boSupportedCountries || [];

    const [activeTab, setActiveTab] = useState(0);
    const [hasFiltered, setHasFiltered] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState('');

    const { t } = useTranslation();

    const handleTabChange = (_: any, newValue: number) => {
        setActiveTab(newValue);
    };

    const tabs = [
        { label: t('otpPassword.smsPassword'), tooltip: t('otpPassword.smsPassword') },
        { label: t('otpPassword.updateHistory'), tooltip: t('otpPassword.updateHistory') },
    ];

    return (
        <SCUIContent className={OTPP.page}>
            <Box className={OTPP.layout} sx={{ padding: '16px', marginTop: '16px' }}>
                <div className={OTPP.breadcrumbSection}>
                    <SCUIBreadCrumb
                        title={t('otpPassword.title')}
                        componentLink={'/password-sms-management'}
                        onClick={() => setHasFiltered(false)}
                    />
                </div>
                {!hasFiltered ? (
                    <Box
                        className={OTPP.emptyState}
                        sx={{
                            padding: '16px',
                            justifyContent: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <div className={OTPP.emptyNoRecord}>
                            <SCUINoRecordComponent />
                        </div>
                        <FormControl className={OTPP.filterFormControl} style={{ width: '60%', marginTop: '16px' }}>
                            <InputLabel className={OTPP.filterInputLabel} id="countrySelect">
                                {t('otpPassword.selectCountry')}
                            </InputLabel>
                            <Select
                                className={OTPP.filterSelect}
                                sx={{ marginBottom: '16px' }}
                                id="countrySelect"
                                label={t('otpPassword.selectCountry')}
                                value={selectedCountry || ''}
                                onChange={(event) => {
                                    setSelectedCountry(event.target.value);
                                }}
                                fullWidth
                            >
                                {(countries || []).map((country: any) => (
                                    <MenuItem
                                        className={OTPP.filterMenuItem}
                                        key={country.countryId}
                                        id={country.countryId}
                                        value={country.countryId}
                                    >
                                        <img
                                            className={OTPP.filterMenuItemFlagImg}
                                            src={country.flagUrl}
                                            alt={country.countryCode}
                                            style={{
                                                width: '30px',
                                                height: '20px',
                                                marginRight: '8px',
                                                objectFit: 'contain',
                                            }}
                                        />
                                        <span className={OTPP.filterMenuItemText} style={{ fontSize: '14px' }}>
                                            {country.countryName} | {country.countryCode}
                                        </span>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <SCUIButton
                            className={OTPP.filterButton}
                            text={t('general.filter')}
                            type="primary"
                            sizeType="fixed"
                            size={'m'}
                            onClick={() => setHasFiltered(true)}
                        />
                    </Box>
                ) : (
                    <Box className={OTPP.tabsSection}>
                        <Tabs
                            className={OTPP.tabs}
                            value={activeTab}
                            onChange={handleTabChange}
                            sx={{
                                '& .MuiTab-root': {
                                    padding: '8px',
                                    minHeight: '40px',
                                    '&:hover': {
                                        backgroundColor: 'rgba(3, 169, 244, 0.7)',
                                        color: '#ffffff !important',
                                    },
                                },
                            }}
                        >
                            {tabs.map((tab) => (
                                <Tab
                                    className={OTPP.tab}
                                    key={tab.label}
                                    label={
                                        <Tooltip title={tab.tooltip} arrow>
                                            <span className={OTPP.tabLabel}>{tab.label}</span>
                                        </Tooltip>
                                    }
                                />
                            ))}
                        </Tabs>
                        <Box className={OTPP.tabPanel} sx={{ mt: 2, p: 1, width: '100%', display: 'flex' }}>
                            {activeTab === 0 && <SMSPassword selectedCountry={selectedCountry} />}
                            {activeTab === 1 && <UpdateHistory selectedCountry={selectedCountry} />}
                        </Box>
                    </Box>
                )}
            </Box>
        </SCUIContent>
    );
};
